import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import {
    ConditionSetting,
    ConditionTableColumn,
    DateTableColumn,
    EmailGesendetTableColumn,
    KieneBooleanTableColumn,
    PdfTableColumn,
    TableColumn,
} from '../../../components/kiene-table/table-column';
import { Condition, Operator, TableOption } from '../../../components/kiene-table/table-option';
import { HttpParams } from '@angular/common/http';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { BestandsbuchArtikelUebersichtComponent } from '../../../../../projects/kiene-core/src/lib/bestandsbuecher/bestandsbuch-artikel-uebersicht/bestandsbuch-artikel-uebersicht.component';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { FormControl } from '@angular/forms';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    Bestandsbuch,
    BestandsbuchAngewandt,
} from '../../../../../projects/kiene-core/src/lib/bestandsbuecher/classes/bestandsbuch';
import { BestandsbuchArtikel } from '../../../../../projects/kiene-core/src/lib/bestandsbuecher/classes/bestandsbuch-artikel';
import { BestandsbuchService } from '../../../../../projects/kiene-core/src/lib/bestandsbuecher/bestandsbuch.service';

@Component({
    selector: 'kiene-bestandsbuch',
    templateUrl: './bestandsbuch.component.html',
    styleUrls: ['./bestandsbuch.component.scss'],
})
export class BestandsbuchComponent implements OnInit {
    // TODO
    permission = 4421;
    tableDescriptor: TableDescriptor = new TableDescriptor();

    currentClient: Client;

    bestandsbuecher: Bestandsbuch[] = [];
    bestandsbuchArtikel: BestandsbuchArtikel[] = [];

    typCtrl = new FormControl(0);
    offeneImpfkontrollbuecher = 0;

    constructor(
        public dialog: MatDialog,
        private readonly pdfService: PdfViewerDesktopService,
        public readonly localStorageService: LocalStorageService,
        private readonly tableService: KieneTableService,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly bestandsbuchService: BestandsbuchService,
    ) {
        this.currentClient = this.localStorageService.getCurrentClient();
    }

    ngOnInit() {
        this.tableDescriptor.headline = 'Bestands- und Impfkontrollbücher';
        this.tableDescriptor.uniqueIdentifier = 'Bestands- und Impfkontrollbücher';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'bestandsbuch/';
        this.tableDescriptor.route = '/belege/bestandsbuecher/';
        this.tableDescriptor.nameOfIdField = 'bestandsbuch_id';
        this.tableDescriptor.searchPlaceholder = 'Bestandsbücher durchsuchen';

        this.tableDescriptor.headlineColumnTitle = 'ID';
        this.tableDescriptor.headlineColumnName = 'bestandsbuch_id';
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.showDetails.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('bestandsbuch_id', 'ID'));

        const typSettings: ConditionSetting[] = [];
        typSettings.push(
            new ConditionSetting([new Condition('typ', Operator.GLEICH, 1)], {
                color: 'black',
                icon: 'menu_book',
                tooltipFieldnames: ['typ_name'],
            }),
        );
        typSettings.push(
            new ConditionSetting([new Condition('typ', Operator.GLEICH, 2)], {
                color: 'black',
                icon: 'vaccines',
                tooltipFieldnames: ['typ_name'],
            }),
        );
        this.tableDescriptor.columns.push(new ConditionTableColumn('typ_name', 'Typ', typSettings));
        this.tableDescriptor.columns.push(new TableColumn('abgabebeleg_nr', 'Abgabebeleg'));

        this.tableDescriptor.columns.push(new TableColumn('kunde', 'Kunde'));
        this.tableDescriptor.columns.push(new TableColumn('zusatz', 'Kundenzusatz'));
        this.tableDescriptor.columns.push(new TableColumn('tierarzt', 'Tierarzt'));
        this.tableDescriptor.columns.push(new TableColumn('status', 'Status'));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('abschliessbar', 'Abschliessbar'));
        this.tableDescriptor.columns.push(new DateTableColumn('datum', 'Belegdatum', 'dd.MM.yy'));
        this.tableDescriptor.columns.push(new PdfTableColumn('pdf_id', 'PDF', this.openPdf.bind(this)));
        this.tableDescriptor.columns.push(new EmailGesendetTableColumn());

        this.tableDescriptor.params = new HttpParams();

        this.tableDescriptor.permissionCreate = 4422;
        this.tableDescriptor.permissionView = 4421;

        this.tableDescriptor.options.push(
            new TableOption(this.openAbgabebelegPdf.bind(this), 'Abgabebeleg anzeigen', 'description', 1238, {
                conditions: [new Condition('pdf_id_abgabebeleg', Operator.EXISTIERT, '')],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.deleteBestandsbuch.bind(this), 'Bestandsbuch löschen', 'delete', 4424),
        );
        this.tableDescriptor.createAllowed = false;

        this.tableDescriptor.initialSortColumn = 'status_sortierung';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.expandable = true;
        this.tableDescriptor.expandableFieldName = 'artikel';
        this.tableDescriptor.openFirstRows = 1;
        this.tableDescriptor.expandableColumns.push(new TableColumn('artikel_me', 'Artikel'));
        this.tableDescriptor.expandableColumns.push(new TableColumn('tierart', 'Tierart'));
        this.tableDescriptor.expandableColumns.push(new TableColumn('anwendung', 'Anwendung'));
        this.tableDescriptor.expandableColumns.push(new TableColumn('diagnose', 'Diagnose'));
        this.tableDescriptor.expandableColumns.push(new TableColumn('artikelmenge', 'Menge'));
        this.tableDescriptor.expandableColumns.push(new TableColumn('anzahl_tiere', 'Anz. Tiere'));
        this.tableDescriptor.expandableColumns.push(new TableColumn('dosierung_txt', 'Dosierung'));
        this.tableDescriptor.expandableColumns.push(
            new TableColumn('anwendungsdauer', 'Anwendungsdauer (Tage)', null, null, null, null, null, null, 'Tage'),
        );
        this.tableDescriptor.expandableColumns.push(new TableColumn('tiergewicht', 'Tiergewicht (kg)'));

        this.tableDescriptor.expandableColumns.push(new TableColumn('wartezeit', 'Wartezeit Fleisch'));

        this.typCtrl.valueChanges.subscribe({
            next: typ => {
                if (typ === 2) {
                    this.ladeOffeneImpfkontrollbuecher();
                }
                this.reload();
            },
        });

        this.ladeOffeneImpfkontrollbuecher();
    }

    gedruckt(bb: Bestandsbuch) {
        this.api
            .get(
                this.apiBaseUrl + 'bestandsbuch/gedruckt.php',
                new HttpParams().set('bestandsbuch_id', bb.bestandsbuch_id),
            )
            .subscribe({
                next: () => {
                    this.tableService.reload('gedruckt');
                    this.openPdf(bb);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
    }

    showDetails(bb: Bestandsbuch) {
        if (bb.status_id === 152) {
            this.openPdf(bb);
        } else {
            this.openBestandsbuchArtikelUebersichtDialog(bb);
        }
    }

    deleteBestandsbuch(bb: Bestandsbuch) {
        const input = new ConfirmDialogInput();
        input.headline = 'Bestandsbuch löschen?';
        input.text = 'Soll das Bestandsbuch unwiderruflich gelöscht werden?';
        input.okButton = 'Löschen';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '50%', minWidth: '300px', data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    this.api.deleteGeneric(this.apiBaseUrl + 'bestandsbuch/delete.php', bb).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Bestandsbuch wurde erfolgreich gelöscht!');
                            this.tableService.reload();
                        },
                        error: err => {
                            this.messageService.errorMessage('Bestandsbuch konnte nicht gelöscht werden!', err);
                        },
                    });
                }
            },
        });
    }

    openAbgabebelegPdf(bestandsbuch: Bestandsbuch) {
        const input = new PdfViewerDialogInput(
            'abgabebeleg/read_or_mail_pdf.php',
            new HttpParams().set('abgabebeleg_id', bestandsbuch.abgabebeleg_id),
            'Abgabebeleg ' + bestandsbuch.abgabebeleg_nr,
            { email: { sende_mail: true, kunde_id: bestandsbuch.kunde_id } },
        );
        this.pdfService.openPdfViewer(input);
    }

    openPdf(bb: Bestandsbuch) {
        const input = new PdfViewerDialogInput(
            'bestandsbuch/read_or_mail_pdf.php',
            new HttpParams().set('bestandsbuch_id', bb?.bestandsbuch_id?.toString()),
            'Bestandsbuch ' + bb?.abgabebeleg_nr,
            { email: { sende_mail: true, kunde_id: bb?.kunde_id } },
        );
        this.pdfService.openPdfViewer(input).subscribe({
            next: () => {
                this.tableService.reload();
            },
        });
    }

    alleBestandsbuecherAbschliessen() {
        this.bestandsbuchService
            .alleBestandsbuecherAbschliessen(this.localStorageService.getCurrentClient()?.kunde_id)
            .subscribe({
                next: (res: boolean) => {
                    if (res) {
                        this.tableService.reload();
                    }
                },
            });
    }

    alleImpfkontrollbuecherAbschliessen() {
        let params = new HttpParams();
        if (this.localStorageService.getCurrentClient()) {
            params = params.set('kunde_id', this.localStorageService.getCurrentClient()?.kunde_id);
        }
        this.api.getAll(this.apiBaseUrl + 'bestandsbuch/read_offene_impfkontrollbuecher.php', params).subscribe({
            next: response => {
                if (response.count > 0) {
                    this.impfkontrollbuecherAbschliessen(response.records, false);
                } else {
                    this.messageService.infoMessage('Keine Impfkontrollbücher zum Abschließen gefunden!');
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    ladeOffeneImpfkontrollbuecher() {
        let params = new HttpParams();
        if (this.localStorageService.getCurrentClient()) {
            params = params.set('kunde_id', this.localStorageService.getCurrentClient()?.kunde_id);
        }
        this.api.getAll(this.apiBaseUrl + 'bestandsbuch/read_offene_impfkontrollbuecher.php', params).subscribe({
            next: response => {
                this.offeneImpfkontrollbuecher = response.count;
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    private openBestandsbuchArtikelUebersichtDialog(bestandsbuch: Bestandsbuch) {
        const dialogRef = this.dialog.open(BestandsbuchArtikelUebersichtComponent, {
            width: '400px',
            data: bestandsbuch,
        });
        dialogRef.afterClosed().subscribe({
            next: () => {
                this.tableService.reload('openBestandsbuchArtikelUebersichtDialog: afterClosed');
            },
        });
    }

    private reload() {
        if (this.typCtrl.value > 0) {
            this.tableDescriptor.params = this.tableDescriptor.params.set('typ', this.typCtrl.value);
        } else {
            this.tableDescriptor.params = this.tableDescriptor.params.delete('typ');
        }
        this.tableService.reload('bestandsbuch typ change');
    }

    private impfkontrollbuecherAbschliessen(buecher: BestandsbuchAngewandt[], force: boolean) {
        if (buecher?.length > 0) {
            const dialogRef = this.dialog.open(BestandsbuchArtikelUebersichtComponent, {
                width: '400px',
                data: buecher[0],
            });
            dialogRef.afterClosed().subscribe({
                next: result => {
                    this.tableService.reload('openBestandsbuchArtikelUebersichtDialog: afterClosed');
                    if (result) {
                        let params = new HttpParams();
                        if (this.localStorageService.getCurrentClient()) {
                            params = params.set('kunde_id', this.localStorageService.getCurrentClient()?.kunde_id);
                        }
                        this.api
                            .getAll(this.apiBaseUrl + 'bestandsbuch/read_offene_impfkontrollbuecher.php', params)
                            .subscribe({
                                next: response => {
                                    if (response.count > 0) {
                                        this.impfkontrollbuecherAbschliessen(response.records, false);
                                    }
                                },
                            });
                    }
                },
            });
        }
    }
}
